import React from 'react';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { colors, typography } from '../../styles';

const styles = css`
  display: none;
  @media (min-width: 992px) {
    display: flex;
    position: relative;
    z-index: 1;
    margin: 0 0 0 0;
    background-color: ${colors.neutralLight};
  }
  .CourtesyNav {
    list-style: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 30px 0 0;
    position: relative;
    width: 100%;
    margin: 0;
  }
  .CourtesyNav_item {
    display: block;
    font-size: 17px;
    font-family: ${typography.Condensed};
    font-weight: 600;
    line-height: 1;
    padding: 0;
    .FavoritesStatus-active {
      @media (min-width: 992px) {
        display:inline-block;
        position:relative;
        padding:0;
        background: none;
      }
    }
  }
  .CourtesyNav_itemLink {
    color: ${colors.body};
    font-size: 14px;
    line-height: 1;
    font-weight: 400;
    padding: 8px 10px;
    display: block;
  }
`;

function CourtesyNav() {
  return (
    <div className={styles} >
      <ul className="CourtesyNav">
        <li className="CourtesyNav_item"><Link name="blog" className="CourtesyNav_itemLink">Blog</Link></li>
        <li className="CourtesyNav_item"><Link name="warranty-request" className="CourtesyNav_itemLink">Customer Care</Link></li>
        <li className="CourtesyNav_item"><Link name="contact-us" className="CourtesyNav_itemLink">Contact Us</Link></li>
      </ul>
    </div>
  );
}

export default CourtesyNav;



// WEBPACK FOOTER //
// ./src/components/Header3/CourtesyNav.js